<template>
    <sign-up-page
        :registration="data"
        :error-messages="errorMessages"
        :countries="countries"
        :wait="wait"
        @update:first_name="data.first_name = $event"
        @update:country_id="data.country_id = $event"
        @update:email="data.email = $event"
        @update:password="data.password = $event"
        @update:password_repeat="data.password_repeat = $event"
        @submit="validate"
    >
        <template v-slot:captcha>
            <vue-recaptcha
                ref="recaptcha"
                size="invisible"
                :sitekey="siteKey"
                @verify="signUp"
                @expired="onCaptchaExpired"
            />
        </template>
    </sign-up-page>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import { publicPages } from '../../config/variant'

export default {
    name: 'SignUpController',
    components: {
        VueRecaptcha,
        SignUpPage: publicPages.signUp,
    },
    data () {
        return {
            countries: [],
            data: {
                country_id: '',
                email: '',
                first_name: '',
                password: '',
                password_repeat: '',
            },
            errorMessages: {
                captcha: [],
                country_id: [],
                email: [],
                first_name: [],
                password: [],
                password_repeat: [],
            },
            siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
            wait: false,
        }
    },
    computed: {
        user: function () {
            return this.$store.getters.user
        },
    },
    created: function () {
        this.getCountries()
    },
    methods: {
        getCountries: function () {
            this.$axios.post('/app/resource/country')
                .then(res => {
                    if (res.data.success) {
                        this.countries = res.data.data
                        this.countries.forEach(c => {
                            if (c.iso === this.user.country) {
                                this.data.country_id = c.id
                            }
                        })
                    }
                })
        },

        onCaptchaExpired () {
            this.$refs.recaptcha.reset()
        },

        signUp: function (recaptchaToken) {
            this.wait = true

            this.$axios.post('/manager/sign-up', {captcha: recaptchaToken, ...this.data})
                .then(res => {
                    if (res.data.success) {
                        this.$axios.defaults.headers.common['Authorization'] = res.data.data
                        this.$store.commit('updateToken', res.data.data)
                        this.$router.push('/')
                    } else {
                        this.errorMessages.captcha = res.data.errors.captcha || []
                        this.errorMessages.country_id = res.data.errors.country_id || []
                        this.errorMessages.email = res.data.errors.email || []
                        this.errorMessages.first_name = res.data.errors.first_name || []
                        this.errorMessages.password = res.data.errors.password || []

                        if (this.errorMessages.captcha.length) {
                            this.$refs.recaptcha.reset()
                        }
                    }

                    this.wait = false
                })
        },

        validate () {
            this.$refs.recaptcha.execute()
        },
    },
}
</script>

<style scoped>
</style>
